import { useEffect, useReducer, useRef, useState } from "react";
import type { ReactNode } from "react";
import { defaultState, loadState, saveState } from "../lib/db";
import { AppStoreContext, reducer } from "./app-store-context";

export function AppStoreProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, undefined, defaultState);
  const [ready, setReady] = useState(false);
  const hydratedRef = useRef(false);

  useEffect(() => {
    let alive = true;
    void loadState().then((loadedState) => {
      if (!alive) return;
      hydratedRef.current = true;
      dispatch({ type: "hydrate", state: loadedState });
      setReady(true);
    });
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    if (!hydratedRef.current) return;
    const timeout = setTimeout(() => void saveState(state), 300);
    return () => clearTimeout(timeout);
  }, [state]);

  return (
    <AppStoreContext.Provider value={{ state, dispatch, ready }}>
      {children}
    </AppStoreContext.Provider>
  );
}
